import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {CheckCircleOutlined, LeftOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import {Button, Form, Input} from 'antd';
import {MaskedInput} from 'antd-mask-input/build/module';
import {observer} from 'mobx-react-lite';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {INDEX} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {MUTATION_DELETE_ACCOUNT} from '../../shared/graphql/delete-account';
import {phoneRegex} from '../../shared/helpers/regex';

import cls from './Policy.module.scss'

export const DeleteAccount = observer(() => {

    const {t} = useTranslation();
    const {auth} = useInstance(Store)
    const navigate = useNavigate();

    const [success, setSuccess] = useState(false);
    const [deleteAccount, deleteAccountData] = useMutation(MUTATION_DELETE_ACCOUNT);

    const onFinish = async (data: any) => {
        console.log('data', data)
        await deleteAccount({
            variables: {
                data: {
                    phone: data.phone,
                    email: data.email,
                }
            },
            onCompleted: () => {
                setSuccess(true);
            }
        })
    }

    const onFine = () => {
        auth.clearState()
        navigate(INDEX)
    }

    return (
        <Layout header={<Header left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                              icon={<LeftOutlined/>}/>}
                                title={t('Delete user account')}/>}>
            <div className={cls.page}>

                {!success &&
                    <>

                        <p>
                            {t('To delete your account, provide your phone number and email')}
                        </p>

                        <Form layout={'vertical'} onFinish={onFinish} validateTrigger={'onFinish'}
                              disabled={deleteAccountData.loading}>
                            <Form.Item name={'phone'} label={t('Phone number')} rules={[
                                {required: true, message: 'Заполните, пожалуйста'},
                                {pattern: phoneRegex, message: 'Не соответствует формату номера телефона'}
                            ]}>
                                <MaskedInput mask={'+7 (000) 000-00-00'} placeholder={'+7 (999) 888-77-66'}
                                             size={'large'}/>
                            </Form.Item>
                            <Form.Item name={'email'} label={'Email'} rules={[
                                {required: true, message: 'Заполните, пожалуйста'},
                                {type: 'email', message: 'Не соответствует формату email'},
                            ]}>
                                <Input placeholder={'name@example.com'}/>
                            </Form.Item>
                            <Form.Item>
                                <Button loading={deleteAccountData.loading} htmlType={'submit'}
                                        type={'primary'}>{t('Send a request')}</Button>
                            </Form.Item>
                        </Form>
                    </>
                }

                {success &&
                    <>
                        <h3>
                            <CheckCircleOutlined className={'green'}/> {t('Application accepted')}
                        </h3>
                        <p>
                            {t('The account will be deleted within 72 hours')}
                        </p>
                        <Button onClick={onFine}>{t('Fine')}</Button>
                    </>
                }

            </div>

        </Layout>
    )

})